import { useState, useEffect } from 'react';
import axios from '../services/Axios';
import GLOBAL from '../global';

const vaApi = process.env.REACT_APP_VA_API_URL;

let cachedPromise = null;
let cachedData = null;

export const fetchDeviceCompatibility = () => {
    if (cachedData) {
        return Promise.resolve(cachedData);
    }
    
    if (!cachedPromise) {
        cachedPromise = axios.post(`${vaApi}/api/RealTimeDetection/GetDeviceCompatibility`, {
            Tenant: GLOBAL.TENANT
        }).then(response => {
            const data = response?.data || response;
            if (data?.Successful) {
                cachedData = data.Message;
            } else {
                cachedData = { IsEnabled: false };
            }
            return cachedData;
        }).catch(error => {
            console.error("Failed to fetch device compatibility notice:", error);
            cachedData = { IsEnabled: false };
            return cachedData;
        });
    }
    
    return cachedPromise;
};

const useDeviceCompatibility = () => {
    const [compatibilityData, setCompatibilityData] = useState(cachedData);
    const [isLoading, setIsLoading] = useState(!cachedData);

    useEffect(() => {
        if (!cachedData) {
            let isMounted = true;
            fetchDeviceCompatibility().then(data => {
                if (isMounted) {
                    setCompatibilityData(data);
                    setIsLoading(false);
                }
            });
            return () => { isMounted = false; };
        } else {
            setCompatibilityData(cachedData);
            setIsLoading(false);
        }
    }, []);

    return {
        isMobileAppSuggestionModalEnabled: compatibilityData?.IsEnabled || false,
        deviceCompatibilityData: compatibilityData,
        isLoading
    };
};

export default useDeviceCompatibility;
